import React from 'react';
import {useTranslation} from 'react-i18next';
import Won from '../won/won';
import DigitBall from '@/common-pages/pick-digit/components/digit-ball';

const rightIcon = require('@components/assets/icons/me-list-item/right-icon.webp');

export interface DigitResultProps {
  wonCode?: string;
  codeLists?: {
    indexCode: string;
    pickAmount: number;
    pickCount: number;
    wonCode: string;
    winAmount?: number;
  }[];
}

const DigitResult = ({wonCode = '***', codeLists = []}: DigitResultProps) => {
  const {i18n} = useTranslation();

  const winList = React.useMemo(() => {
    return codeLists.filter(item => item.winAmount && item.winAmount > 0);
  }, [codeLists]);

  return (
    <div>
      <div className="mt-2 flex items-center justify-between bg-[#F4F4F4] px-3 py-2">
        <div className="flex-1">
          <span className="font-bold">
            {i18n.t('bets-detail.label.drawRes')}：
          </span>
        </div>
        <div className="flex items-center gap-1.5">
          {['A', 'B', 'C'].map((item, _i) => (
            <DigitBall key={_i} digit={item} color={item} fontSize={16} />
          ))}
          <span className="text-sm font-bold">=</span>
          {['A', 'B', 'C'].map((item, _i) => (
            <DigitBall
              key={_i}
              digit={wonCode[_i]}
              color={item}
              fontSize={16}
            />
          ))}
        </div>
      </div>
      {winList.length > 0 && (
        <div className="mt-2 flex flex-col gap-2">
          {winList.map((item, _i) => {
            const indexArr = item.indexCode.split('=');
            const codes = indexArr[1];
            const codeArr = codes.split('');
            const arr = [] as string[];
            const abcArr = indexArr[0]
              .split('')
              .map(p => ['A', 'B', 'C'].findIndex(pie => pie === p));
            abcArr.map((pie, i) => (arr[pie] = codeArr[i]));
            return (
              <Won
                key={_i}
                awardAmount={item.winAmount!}
                result={
                  <div className="flex">
                    <span className="text-sm font-bold">{indexArr[0]}</span>
                    <span className="text-sm font-bold">=</span>
                    <div className="flex">
                      {arr.map((pie, _ii) => (
                        <span
                          key={_ii}
                          className="text-sm font-bold"
                          style={{
                            color: wonCode[_ii] === pie ? '#F15802' : '#48505D',
                          }}>
                          {pie}
                        </span>
                      ))}
                    </div>
                    <div className="ml-2 rounded bg-[#F15802] px-1 py-0.5">
                      <span className="text-xs font-bold text-white">
                        x{item.pickCount}
                      </span>
                    </div>
                  </div>
                }
                isBet={false}
              />
            );
          })}
        </div>
      )}
      <div className="mt-2 flex max-h-[6.75rem] flex-wrap gap-2 overflow-hidden">
        {codeLists.map((item, _i) => (
          <div
            className="flex h-9 items-center justify-center rounded-[1.125rem] bg-[#F6F7FB] px-4"
            key={_i}>
            <span className="font-bold">{item.indexCode}</span>
            <div className="ml-2 rounded bg-[#F15802] px-1 py-0.5">
              <span className="text-xs font-bold text-white">
                x{item.pickCount}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div style={stylesWeb.over}>
        <div className="flex items-center justify-center pb-2">
          <span className="font-bold">View Details</span>
          <img src={rightIcon} alt="" className="ml-2 h-4 w-4" />
        </div>
      </div>
    </div>
  );
};

const stylesWeb: Record<string, React.CSSProperties> = {
  over: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    paddingTop: '5rem',
    background: 'linear-gradient(180deg, #FFFFFF00 0%, #FFFFFF 100%)',
  },
};

export default DigitResult;
